"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileError = exports.FileInput = exports.FileRemove = exports.FileLabelDescription = exports.FileLabelTitle = exports.FileLabel = exports.FileHandle = exports.FileButton = exports.FileContainer = void 0;

var _polished = require("polished");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _removeFileIcon = _interopRequireDefault(require("../../../../public/images/icons/remove-file-icon.svg"));

var _motion = require("../../../style/motion");

var _selectors = require("../../../style/selectors");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FileButtonSelector = _styledComponents["default"].div.withConfig({
  displayName: "FileFieldstyled__FileButtonSelector",
  componentId: "csdg50-0"
})([""]);

var FileContainer = _styledComponents["default"].label.withConfig({
  displayName: "FileFieldstyled__FileContainer",
  componentId: "csdg50-1"
})(["position:relative;&:hover ", "{box-shadow:5px 12px 26px ", ";}&:hover ", "::before{opacity:1;}"], FileButtonSelector, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.irisBlue_45;
}, FileButtonSelector);

exports.FileContainer = FileContainer;
var FileButton = (0, _styledComponents["default"])(FileButtonSelector).withConfig({
  displayName: "FileFieldstyled__FileButton",
  componentId: "csdg50-2"
})(["display:flex;align-items:center;position:relative;mix-blend-mode:normal;padding:14px;font-size:", ";color:var(--colors-blank);box-shadow:5px 12px 26px ", ";background-color:var(--brandPrimary);box-sizing:border-box;border-radius:10px;text-decoration:none;transition:box-shadow 0.25ms ease-in-out;z-index:1;cursor:pointer;&::before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;background-image:linear-gradient( 58.31deg,rgba(134,114,252,0.72) -6.33%,rgba(132,112,248,0.5) 107.96% );z-index:-1;transition:opacity 0.25s linear;opacity:0;pointer-events:none;border-radius:10px;box-shadow:0 0 0 3px rgba(255,255,255,0.1) inset;}", ";", ""], (0, _polished.rem)('16px'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.irisBlue_15;
}, function (_ref3) {
  var theme = _ref3.theme;
  return (0, _selectors.focusVisible)((0, _styledComponents.css)(["box-shadow:0 0 0 3px ", ",0 0 0 5px ", ";"], theme.colors.blank, theme.colors.irisBlue));
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mode === 'dark' && (0, _styledComponents.css)(["background-color:var(--brandPrimary);"]);
});
exports.FileButton = FileButton;

var FileHandle = _styledComponents["default"].span.withConfig({
  displayName: "FileFieldstyled__FileHandle",
  componentId: "csdg50-3"
})(["display:flex;svg{height:24px;width:auto;}"]);

exports.FileHandle = FileHandle;

var FileLabel = _styledComponents["default"].span.withConfig({
  displayName: "FileFieldstyled__FileLabel",
  componentId: "csdg50-4"
})(["margin-left:12px;display:flex;align-items:start;flex-direction:column;justify-content:center;"]);

exports.FileLabel = FileLabel;

var FileLabelTitle = _styledComponents["default"].span.withConfig({
  displayName: "FileFieldstyled__FileLabelTitle",
  componentId: "csdg50-5"
})(["font-weight:500;font-size:", ";line-height:", ";margin:0;color:var(--colors-blank);"], (0, _polished.rem)('16px'), (0, _polished.rem)('22px'));

exports.FileLabelTitle = FileLabelTitle;

var FileLabelDescription = _styledComponents["default"].span.withConfig({
  displayName: "FileFieldstyled__FileLabelDescription",
  componentId: "csdg50-6"
})(["font-size:", ";line-height:", ";color:rgba(255,255,255,0.6);margin-top:4px;margin-bottom:0;"], (0, _polished.rem)('13px'), (0, _polished.rem)('18px'));

exports.FileLabelDescription = FileLabelDescription;

var FileRemoveSelector = _styledComponents["default"].input.withConfig({
  displayName: "FileFieldstyled__FileRemoveSelector",
  componentId: "csdg50-7"
})([""]);

var FileRemove = (0, _styledComponents["default"])(_removeFileIcon["default"]).withConfig({
  displayName: "FileFieldstyled__FileRemove",
  componentId: "csdg50-8"
})(["", " fill:transparent;cursor:pointer;path{", " stroke:var(--brandPrimary);}", ":focus + * > &,&:hover{fill:var(--brandPrimary);path{stroke:#fff;}}"], (0, _motion.sharedTransition)('fill'), (0, _motion.sharedTransition)('stroke'), FileRemoveSelector);
exports.FileRemove = FileRemove;
var FileInput = (0, _styledComponents["default"])(FileRemoveSelector).withConfig({
  displayName: "FileFieldstyled__FileInput",
  componentId: "csdg50-9"
})(["opacity:0;position:absolute;top:0;right:10px;bottom:0;left:0;width:100%;z-index:0;cursor:pointer;&:focus + ", "{box-shadow:0 0 0 3px var(--colors-blank),0 0 0 5px var(--colors-irisBlue);}"], FileButtonSelector);
exports.FileInput = FileInput;

var FileError = _styledComponents["default"].div.withConfig({
  displayName: "FileFieldstyled__FileError",
  componentId: "csdg50-10"
})(["margin-top:16px;"]);

exports.FileError = FileError;